var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    /** Will check if a string is null, undefined, empty or only whitespace */
    StringUtils.isNullOrWhitespace = function (input) {
        if (input === undefined || input === null)
            return true;
        return input.replace(/\s/g, '').length < 1;
    };
    /** If 1 word, will return that word, otherwise will return comma separated words,
     *  until the last 2 which will be separated by ' and '*/
    StringUtils.commasAnd = function (words) {
        switch (words.length) {
            case 0: return "";
            case 1: return words[0];
            default:
                var last2Words = words.slice(words.length - 2);
                var joinWords = words.slice(0, words.length - 2).concat(["".concat(last2Words[0], " and ").concat(last2Words[1])]);
                return joinWords.join(", ");
        }
    };
    return StringUtils;
}());
export default StringUtils;
